module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/stethscope-dc639270a855cc84c64f5687c84f361b.svg";